import { Injectable } from '@angular/core';
import { createSafeProps } from 'src/lib/tcs-app-insights/app-insights-util';
import { Logger, LogMessage } from 'pubnub';
import { CacheLogger } from '../../tcs-logging/cache-logger';
import { LoggerOptionsService } from '../../tcs-logging/logger-options.service';
import { parsePubnubLog } from '../pubnub-config';

@Injectable()
export class PubnubCacheLogger implements Logger {
  constructor(private _logger: CacheLogger, private _loggerSettings: LoggerOptionsService) {}

  public error(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.error(`PubnubCacheLogger Error: ${message}`, safeLog);
    }
  }
  public info(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubCacheLogger Info: ${message}`, safeLog);
    }
  }
  public warn(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.warning(`PubnubCacheLogger Warning: ${message}`, safeLog);
    }
  }
  public debug(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubCacheLogger Debug: ${message}`, safeLog);
    }
  }
  public trace(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubCacheLogger Trace: ${message}`, safeLog);
    }
  }
}
